// test api endpoint
// export const baseUrl = "http://192.168.15.51/api/admin-terminal/";

// test api endpoint
// export const baseUrl = "https://devterm.alif.mobi/api/";

// export const baseUrl = "https://devterm.alif.mobi/api2/";
// test api3 endpoint
// export const baseUrl = "http://192.168.15.51/api/admin-terminal-mijgona/";

// test aki jasur endpoint
// export const baseUrl = "https://devterm.alif.mobi/api2/";

// prod api endpoint
export const baseUrl = "https://control-panel.term.alif.uz/api";
